import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useIntl } from 'gatsby-plugin-react-intl';
import clip from 'text-clipper';

import RichText from '../../../Core/RichText';
import playButton from '../../../../images/play-button.svg';

import {
  Tile,
  Card,
  CardBackground,
  Tag,
  Title,
  StyledLink,
  Image,
  TimeStamp,
  VideoTileWrapper,
} from './styles';

const VideoTutorialTile = ({
  url,
  title = null,
  description = null,
  thumbnail = null,
  duration = null,
  className = '',
}) => {
  const intl = useIntl();

  const thumb =
    thumbnail && thumbnail ? thumbnail.asset.localImage.publicURL : null;

  // * Convert duration to readable minutes and seconds
  const hours = Math.floor(duration / 60 / 60);
  const minutes = Math.floor(duration / 60) - hours * 60;
  const seconds = duration % 60;
  const formattedDuration = `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;

  // * max char count before we trim the text, and add a See more if a CTA has also been provided
  const maxCount = 68;

  return (
    <VideoTileWrapper>
      <StyledLink
        to={url}
        className={`${className} unstyled-link`}
        ariaLabel={`${intl.formatMessage({
          id: 'Video',
        })} ${intl.formatMessage({
          id: 'HowTo',
        })} ${title}`}
        title={`${intl.formatMessage({
          id: 'HowTo',
        })} ${title}`}
      >
        <Tile>
          <Card className="card">
            <CardBackground background={thumb && thumb ? thumb : null} />
            <Tag>
              {intl.formatMessage({
                id: 'Video',
              })}
            </Tag>
            <Title>
              {`${intl.formatMessage({
                id: 'HowTo',
              })}`}{' '}
              <span>
                {ReactHtmlParser(
                  clip(title, maxCount, {
                    breakWords: true,
                    html: true,
                  }),
                )}
              </span>
            </Title>
            <Image src={playButton} alt="" />
            <TimeStamp>{formattedDuration}</TimeStamp>
          </Card>
        </Tile>
      </StyledLink>
      {description && <RichText document={description} />}
    </VideoTileWrapper>
  );
};

VideoTutorialTile.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.shape(),
  className: PropTypes.string,
  thumbnail: PropTypes.shape(),
  duration: PropTypes.number,
};

export default VideoTutorialTile;
